import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export const GlobalSearchBar = ({ initial = "", autoFocus = false, className = "" }) => {
  const [q, setQ] = useState(initial);
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    const t = q.trim();
    if (t.length >= 2) navigate(`/search?q=${encodeURIComponent(t)}`);
  };
  return (
    <form onSubmit={submit} className={`relative ${className}`} data-testid="global-search-form">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        autoFocus={autoFocus}
        placeholder="Search a client or rep name — see orders, proposals and messages"
        className="w-full h-12 pl-11 pr-28 rounded-full border border-zinc-200 bg-white shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-shadow"
        data-testid="global-search-input"
      />
      <button type="submit" disabled={q.trim().length < 2}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 h-9 px-5 rounded-full bg-primary text-primary-foreground text-sm font-medium disabled:opacity-40 hover:opacity-90 transition-opacity"
        data-testid="global-search-submit">
        Search
      </button>
    </form>
  );
};
